const CardWithTitleAndIcon = ({
  containerStyle,
  borderColor,
  height,
  width,
  onClick,
  hasIcon,
  hasSVG,
  cardTitle,
  count,
  contentStyle,
  boxShadow,
  imgWidth,
  imgHeight,
  customImage,
  containerImgHeight,
  containerImgWidth,
  style,
  id,
}) => (
  <div
    className={containerStyle}
    id={id}
    style={{
      border: `1px solid ${borderColor ?? "#1A73E8"}`,
      borderRadius: "4px",
      height: height ?? 90,
      width: width ?? 200,
      cursor: "pointer",
      boxShadow: boxShadow,
      ...style,
    }}
    onClick={onClick}
  >
    {hasIcon ?? null}
    {customImage ? (
      <div
        style={{
          height: containerImgHeight ?? 30,
          width: containerImgWidth ?? 30,
          borderRadius: "50%",
        }}
        className="d-flex justify-content-center text-center align-items-center px-1"
      >
        <img
          src={customImage}
          width={imgWidth ?? 18}
          height={imgHeight ?? 18}
          alt=""
        />
      </div>
    ) : null}

    {hasSVG ?? null}
    {count || cardTitle ? (
      <div
        className={`d-flex flex-column m-2 ${contentStyle}`}
        style={{ fontSize: 16 }}
      >
        {count ? <div className="mx-1">{count}</div> : null}
        {cardTitle ? <p className="my-2 text-center">{cardTitle}</p> : null}
      </div>
    ) : null}
  </div>
);

export default CardWithTitleAndIcon;
